import { client } from './generated/client.gen';

const AUTH_TOKEN_KEY = 'webapp:accessToken';

const PROD_API_URL =
  'https://dxpuw6f7o9.execute-api.eu-central-1.amazonaws.com/dev/';

/**
 * The Authorization header is NOT persisted into the hey-api client's
 * `_config`. Instead we install a request interceptor that reads the token
 * from localStorage on every outgoing request. That keeps localStorage as
 * the single source of truth and avoids the race we hit where
 * `client.setConfig({ headers })` wasn't observed by queries fired in the
 * same tick as login (producing requests with no Authorization header).
 */

let interceptorInstalled = false;

const installAuthInterceptor = () => {
  if (interceptorInstalled) return;
  interceptorInstalled = true;

  client.interceptors.request.use((request) => {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token && !request.headers.has('Authorization')) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }
    return request;
  });
};

export const setupApiClient = () => {
  const isDevServer =
    import.meta.env.DEV && window.location.protocol === 'http:';
  const baseUrl = isDevServer
    ? ''
    : import.meta.env.VITE_API_URL ?? PROD_API_URL;

  client.setConfig({ baseUrl });
  installAuthInterceptor();
};

export const setApiAuth = (token: string) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearApiAuth = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const getStoredToken = (): string | null => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};
